import { combineReducers } from "redux";

import * as rootURL from "./rootURL";

export const reducer = combineReducers({
  rootURL: rootURL.reducer,
});

export interface StoreState {
  rootURL: rootURL.StoreState;
}
